import React, { useState } from 'react'
import { Grid } from 'semantic-ui-react'

import EmbedCodeChoiceOrderForm from 'components/EmbedCodeChoiceOrderForm'
import GenerateIntercomEmbedCodeModal from './GenerateIntercomEmbedCodeModal'
import { EmbedPreview } from 'components/EmbedPreview'
import { getIntercomCSATEmbedCode, getIntercomNPSEmbedCode, INTERCOM_TEXT_SOUCRE } from './utils'
import { generateSatisfactionRatingLinkWithoutRating } from 'components/GenerateEmbedCodeModal/utils'
import SurveyPublishDescription from 'components/SurveyPublishDescription'
import useFeatureToggle from 'hooks/useFeatureToggle'

/**
 *
 * @param {object} props
 * @param {object} props.primaryQuestion
 * @param {object} props.language
 * @param {string} props.surveyToken
 * @param {object} props.intercomSurveyConfiguration
 * @param {boolean} props.isReverseOrder survey-level `settings.setups.choiceOrder`
 *   passed down from the parent page (mirrors CSATEmbed) — used when the
 *   `enable_rating_choice_order` flag is on
 */
export default function IntercomTextPublish({
  primaryQuestion,
  surveyToken,
  language,
  intercomSurveyConfiguration,
  isReverseOrder,
}) {
  const { enableRatingChoiceOrder } = useFeatureToggle()
  // Pre-flag behaviour: a page-local toggle that never persisted. Kept while
  // the flag is off (AC10); the survey-level value takes over when it is on.
  const [localReverseOrder, setLocalReverseOrder] = useState(false)
  const effectiveReverseOrder = enableRatingChoiceOrder
    ? Boolean(isReverseOrder)
    : localReverseOrder

  const iframeHeight = 140
  const placeholders = intercomSurveyConfiguration.embedPlaceholders

  const isCSATMetric = primaryQuestion.metric === 'CSAT'
  const isCESMetric = primaryQuestion.metric === 'CES'
  let htmlEmbedCode
  if (isCSATMetric) {
    htmlEmbedCode = getIntercomCSATEmbedCode(
      primaryQuestion,
      surveyToken,
      placeholders,
      language,
      effectiveReverseOrder
    )
  } else {
    // NPS is value-keyed and out of scope for PET-1967 — never reverse. Only
    // CES honors the flip via the shared numeric-embed code path.
    const shouldReverse = isCESMetric ? effectiveReverseOrder : false
    htmlEmbedCode = getIntercomNPSEmbedCode(
      primaryQuestion,
      surveyToken,
      placeholders,
      shouldReverse
    )
  }

  const ratingLinkWihtoutValue = generateSatisfactionRatingLinkWithoutRating(
    surveyToken,
    placeholders,
    INTERCOM_TEXT_SOUCRE,
    false
  )

  return (
    <Grid stackable className=" mb4">
      <Grid.Column width={8} wide>
        <SurveyPublishDescription
          content={intercomSurveyConfiguration.sendAsTextOverview.content}
          linkText={intercomSurveyConfiguration.sendAsTextOverview.linkText}
          linkUrl={intercomSurveyConfiguration.sendAsTextOverview.linkUrl}
        />
        {isCSATMetric && !enableRatingChoiceOrder && (
          <EmbedCodeChoiceOrderForm value={localReverseOrder} onChange={setLocalReverseOrder} />
        )}
        <GenerateIntercomEmbedCodeModal
          className="mt4"
          description={intercomSurveyConfiguration.sendAsTextEmbedModal}
          htmlEmbedCode={htmlEmbedCode}
          iframeHeight={iframeHeight}
          ratingLinkWihtoutValue={ratingLinkWihtoutValue}
        />
      </Grid.Column>
      <Grid.Column width={8} wide>
        <EmbedPreview htmlEmbedCode={htmlEmbedCode} embedPreviewIframeHeight={iframeHeight} />
      </Grid.Column>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomTextPublish/index.js